export default __webpack_public_path__ + "static/media/widget_watchbox_vpmes1d_buy.6284b023.mp3";